import { render } from "./ForgotPasswordReset.vue?vue&type=template&id=f99f4838&scoped=true"
import script from "./ForgotPasswordReset.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordReset.vue?vue&type=script&lang=js"

import "./ForgotPasswordReset.vue?vue&type=style&index=0&id=f99f4838&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99f4838"]])

export default __exports__